import { toolActivity } from '../../app-connection/types'
import { z } from 'zod'

export const sendNextMessageResult = z.object({
    toolActivities: toolActivity.array().default([]),
    message: z.string(),
    conversationLanguage: z.string().nullable().optional(),
})

export type SendNextMessageResult = z.infer<typeof sendNextMessageResult>
